import React from "react";
import { enumLabel } from "./enumLabel";
import "./EnumBadge.css";
export function enumTone(value?: string | null): string {
  const key = (value || "").toLowerCase();
  if (/failed|cancel|declined|blocked|high/.test(key)) return "red";
  if (/complete|delivered|successful|resolved|answered|closed|active/.test(key)) return "green";
  if (/pending|awaiting|medium/.test(key)) return "amber";
  if (/transit|process|checked|shipped|sea|electronic/.test(key)) return "blue";
  if (/air|express|packed|clothing|food/.test(key)) return "purple";
  return "slate";
}
export default function EnumBadge({ value, label }: { value?: string | null; label?: string }) {
  return <span className={`navo-enum-badge navo-enum-badge--${enumTone(value)}`}>{label || (value ? enumLabel(value) : "Not specified")}</span>;
}
